import { render, staticRenderFns } from "./InvoiceFieldsForm.vue?vue&type=template&id=4be949c2"
import script from "./InvoiceFieldsForm.vue?vue&type=script&lang=js"
export * from "./InvoiceFieldsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports